import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Vuex from 'vuex';
import { VueReCaptcha } from 'vue-recaptcha-v3'

import FormApp from '../components/FormApp';
import store from '../store/store'
// import sentry via npm instead of cdn
import * as Sentry from "@sentry/vue";


const version = require('../../../package.json').version;
const applicationName = require('../../../package.json').name;

let localDevelopment = process.env.NODE_ENV !== "production"
Vue.config.devtools = localDevelopment


if (localDevelopment) {
  Vue.config.errorHandler = (err, vm, info) => {
      console.error("Custom Error Handler: ", err, vm, info)
  };
  Vue.config.warnHandler = function (err, vm, info) {
      console.warn('Custom Warn handler: ', err, vm.name, info);
  };
} else {
    // new sentry implementation based on the latest version of sentry/vue

    Sentry.init({
      dsn: 'https://2fb472ccf101450bb2a4bab2b526f5ac@o212792.ingest.sentry.io/1339924',
      release: `${applicationName}@${version}`,
      Vue,
      attachProps: true,
      logErrors: false,
      tracesSampleRate: 1.0,
      attachStacktrace: true,
      tracingOptions: {trackComponents: true}
  });
}

// polyfill for object.assign
if (typeof Object.assign != 'function') {
  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

Vue.use(Vuelidate);
Vue.use(Vuex);
Vue.use(VueReCaptcha, { siteKey: '6LfCy_MZAAAAAOYoaD-PgnPKlBUGq8iH0xqt3YnI' })

Vue.component('form-app', FormApp);

new Vue({
    el: '#form-app',
    components: { FormApp },
    store
});
